import React from "react";
import styles from "./InputField.module.css";
import { FaCalendarAlt, FaClock } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { AiFillCloseCircle } from "react-icons/ai";

const InputField = (props) => {
  return (
    <div className={styles.main_input}>
      <text className={styles.label}>{props?.label}</text>
      <div
        className={styles.input}
        style={{
          display: "flex",
          justifyContent: props?.textCenter ? "center" : "space-between",
        }}
      >
        <input
          style={{ width: props?.textCenter ? "20%" : props.width ? props.width : "80%" }}
          placeholder={props?.placeholder}
          className={styles.inner_input}
          disabled={props?.disabled}
          value={props?.value}
          onChange={props?.onChange}
        />
        {props?.rightIcon ? (
          <FaCalendarAlt onClick={props?.onIconClick} className={styles.icon} />
        ) : null}
        {props?.arrow ? (
          <IoIosArrowForward
            onClick={props?.onIconClick}
            className={styles.icon}
          />
        ) : null}
        {props?.clock ? (
          <FaClock className={styles.icon} onClick={props?.onIconClick} />
        ) : null}
        {props?.crossIcon ? (
          <AiFillCloseCircle className={styles.icon} onClick={props?.onIconClick} />
        ) : null}
      </div>
    </div>
  );
};

export default InputField;
